module.exports = __webpack_public_path__ + "img/stock0.411d092b.png";